import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";

import NoteCard from "../Cards/NoteCard";

import { AttributeCardDisplayVariantType } from "./types";

import Residence from "@/screens/Account/Components/Attributes/Residence";
import { type UserProfileAttributes } from "@/schemas/profile/UserProfileAttributes";
import { type AppUserSession } from "@/schemas/auth/session";
import Birthday from "@/Components/PersonalAttributes/Attributes/Birthday";
import RelationshipSelection from "@/Components/PersonalAttributes/Attributes/Relationship";
import RoleSelection from "@/Components/PersonalAttributes/Attributes/Role";

type BasicAttributesProps = {
  session: AppUserSession;
  attributes: Partial<UserProfileAttributes>;
  variant: AttributeCardDisplayVariantType;
};

// This corresponds to the "Personal Details" section in the Onboarding and Account screen
function BasicAttributes({
  session,
  attributes,
  variant,
}: BasicAttributesProps): React.JSX.Element {
  const isAccountScreen = variant === AttributeCardDisplayVariantType.ACCOUNT;

  return (
    <View style={isAccountScreen ? styles.container : null}>
      {isAccountScreen && (
        <>
          <View style={styles.sectionContainer}>
            <Ionicons
              name="information-circle-outline"
              size={25}
              color="#01579b"
            />
            <Text style={styles.sectionTitle}>{"Personal Details"}</Text>
          </View>
          <NoteCard
            text="These details help others find and connect with you. All fields
              are optional."
          />
        </>
      )}
      <View style={styles.grid}>
        {isAccountScreen && (
          // Since Residence is disabled, it is not included in onboarding
          // TODO: Modify and re-enable Residence in onboarding when ready
          <Residence
            session={session}
            residence={attributes.residence || null}
          />
        )}
        <Birthday
          session={session}
          birthdayStr={attributes.birthday || null}
          variant={variant}
        />
        <RelationshipSelection
          session={session}
          status={attributes.relationship || null}
          variant={variant}
        />
        <RoleSelection
          session={session}
          roleValue={attributes.role || null}
          variant={variant}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 16,
  },
  sectionContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
  },
  sectionTitle: {
    fontSize: 20,
    marginLeft: 5,
    fontWeight: "bold",
  },
  grid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
});

export default BasicAttributes;
